// ESM wrapper for @material-ui/core - re-exports and sets up globals for sharing
export * from '@material-ui/core';
import * as MUI from '@material-ui/core';
export default MUI;

// Set window global for shared instance
if (typeof window !== 'undefined') {
  window.__SHARED_MUI__ = MUI;
}
